
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { AlertCircle, Send } from 'lucide-react';
import { Alert, AlertDescription } from '@/components/ui/alert';

interface PhoneNumberInputProps {
  phoneNumber: string;
  loading: boolean;
  onPhoneNumberChange: (value: string) => void;
  onRequestOTP: () => void;
  error?: string | null;
}

export const PhoneNumberInput = ({
  phoneNumber,
  loading,
  onPhoneNumberChange,
  onRequestOTP,
  error,
}: PhoneNumberInputProps) => {
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onRequestOTP();
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div className="space-y-2">
        <label htmlFor="phone-number" className="text-sm font-medium">
          Mobile Number
        </label>
        <Input
          id="phone-number"
          type="tel"
          placeholder="Enter Australian mobile (e.g. 0412345678)"
          value={phoneNumber}
          onChange={(e) => onPhoneNumberChange(e.target.value)}
          pattern="^(\+?61|0)[4-5]\d{8}$"
          required
          className="focus:ring-2 focus:ring-offset-1"
        />
        <p className="text-xs text-gray-500">
          Format: 0412345678 or +61412345678
        </p>
      </div>
      
      {error && (
        <Alert variant="destructive">
          <AlertCircle className="h-4 w-4" />
          <AlertDescription className="ml-2">{error}</AlertDescription>
        </Alert>
      )}
      
      <Button 
        type="submit"
        className="w-full"
        disabled={loading || !phoneNumber.trim()}
      >
        {loading ? (
          <>Sending Code...</>
        ) : (
          <>
            <Send className="mr-2 h-4 w-4" /> 
            Send Verification Code
          </>
        )}
      </Button>
    </form>
  );
}
